import React from 'react'
import RewardImageTest from '../../assets/images/achievements/RewardImageTest.png'
import { ReactComponent as ArchiveIcon } from '../../svg/achievements/ArchiveIcon.svg'
import { useTranslation } from 'react-i18next'

function OurRewards() {
    const { t } = useTranslation()
    return (
        <div className="achievements-center-body-right ">
            <div className="grey-small-scroll" style={{ paddingRight: 15, maxHeight: 500, overflow: 'auto' }}>
                <div className="achievements-center-body-selection">
                    <div className="achievements-center-body-selection-text">{t('Our Rewards')}</div>
                    <div className="achievements-center-body-selection-archive-container">
                        <ArchiveIcon />
                        <div className="achievements-center-body-selection-archive">{t('archive')}</div>
                    </div>
                </div>
                <div className="achievements-center-body-selection-subtext">{t('Exchange your points into rewards')}</div>
                <div className="achievements-center-rewards-list">
                    {[1, 2, 3, 4, 5].map((item, index) => {
                        return (
                            <div className="achievements-center-rewards-item" key={index} style={{ backgroundRepeat: 'no-repeat', backgroundImage: `url(${RewardImageTest})` }}>
                                <div className="achievements-center-rewards-item-points">
                                    <div>{100}</div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default OurRewards
